export default {
  'subscriptionList.title': 'Subscription List',
  'subscriptionList.form.shopifyId': 'Shopify Store ID',
  'subscriptionList.form.shopifyId.placeholder': 'Shopify Store ID',
  'subscriptionList.form.status': 'Subscription Status',
  'subscriptionList.form.status.placeholder': 'Please select status',
  'subscriptionList.form.customerEmail': 'Customer Email',
  'subscriptionList.form.customerEmail.placeholder': 'Customer Email (fuzzy)',
  'subscriptionList.form.originalOrderId': 'Original Order ID (first)',
  'subscriptionList.form.originalOrderId.placeholder':
    'Original Order ID (first)',
  'subscriptionList.form.subscriptionOrderId': 'Subscription Order ID',
  'subscriptionList.form.subscriptionOrderId.placeholder':
    'Subscription Order ID',
  'subscriptionList.form.dateRange': 'Date Range',
  'subscriptionList.form.startDate': 'Start Date',
  'subscriptionList.form.endDate': 'End Date',
  'subscriptionList.form.search': 'Search',
  'subscriptionList.form.reset': 'Reset',
  'subscriptionList.columns.index': '#',
  'subscriptionList.columns.shopifyId': 'Shopify Store ID',
  'subscriptionList.columns.customerEmail': 'Customer Email',
  'subscriptionList.columns.status': 'Status',
  'subscriptionList.columns.originalOrderId': 'Original Order ID',
  'subscriptionList.columns.subscriptionOrderId': 'Subscription Order ID',
  'subscriptionList.columns.createdAt': 'Created At',
  'subscriptionList.columns.updatedAt': 'Updated At',
  'subscriptionList.columns.operations': 'Actions',
  'subscriptionList.columns.operations.unsubscribe': 'Unsubscribe',
  'subscriptionList.columns.operations.unsubscribeConfirm':
    'Are you sure you want to unsubscribe?',
  'subscriptionList.columns.operations.unsubscribeSuccess':
    'Unsubscribed successfully',
  'subscriptionList.columns.operations.unsubscribeError':
    'Failed to unsubscribe',
  'subscriptionList.status.active': 'Active',
  'subscriptionList.status.paused': 'Paused',
  'subscriptionList.status.cancelled': 'Cancelled',
  'subscriptionList.status.failed': 'Failed',
  'subscriptionList.status.expired': 'Expired',
  'subscriptionList.status.renewed': 'Renewed',
};
